export default [
    {title: "Subscriptions.SubscriptionStatus.Accepted", value: "1"},
    {title: "Subscriptions.SubscriptionStatus.Rejected", value: "2"},
    {title: "Subscriptions.SubscriptionStatus.Pending", value: "3"}
]
